module.exports = __webpack_public_path__ + "static/img/icon_logo.cbe5d8e3.png";